import { render, staticRenderFns } from "./AddMarketRuleWay.vue?vue&type=template&id=57268960"
import script from "./AddMarketRuleWay.vue?vue&type=script&lang=js"
export * from "./AddMarketRuleWay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports